import { Glass, GlassExtended } from './../dossier';

export interface GlassUsageConfiguration {
  otherGlasses?: Glass[];
  treeDisplay: GlassDisplayElement[];
}

export interface GlassDisplayElement {
  glass: Glass;
  glassExtended?: GlassExtended;
  behavior?: GlassBehavior;
  sub?: GlassQuestion[];
}

export type GlassBehavior =
  | 'bookableByPhone'
  | 'bookableByCallBack'
  | 'exit'
  | 'declarationEnd'
  | 'checkWithAgent'
  | 'absenceOfInsurance';

export interface GlassQuestion {
  key: string;
  values: (
    | string
    | boolean
    | { value: string | boolean; behavior?: GlassBehavior }
  )[];
}

export interface Answers {
  value: GlassExtended;
  sub: { key: string; value: string | boolean }[];
}
export interface AnswerChoice {
  glass: Glass;
  glassExtended?: GlassExtended;
  isDisplayUpdated?: boolean;
  sub: { [key: string]: string | boolean };
}
